<script>
import Form from '../Form.vue'
import * as categoryService from '../../service/category.service';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    setTopbarControls: {
      type: Function,
      required: false
    },
    topbarControls: {
      type: Object,
      required: false
    },
    updateSelectedItem: {
      type: Function,
      required: false
    },
  },
  components: {
    Form,
  },
  data(){
    return {
      selectedItem: new Object,
      prevSelectedItem: '{}',
}
  },
  computed: {
  },
  methods: {
    setSelectedItems(val) {
      this.selectedItem = val;
      this.prevSelectedItem = JSON.stringify(val);
      this.setTopbarControls(null, null, this.selectedItem, this.prevSelectedItem)
    },
    async getData() {
      const data = await categoryService.get(this.$route.params.categoryId)
      this.setSelectedItems(data);
    }
  },
  async mounted() {
    await this.getData();
  }
};
</script>
<template>
  <Form
      :style="item.form.style"
      :class="`col-${item.form.size} ${item.form.class}`"
      :form="item.form.form"
      :variant="item.form.variant"
      :data="selectedItem"
      :topbarControls="topbarControls"
      :selectedItem="selectedItem"
      :setSelectedItems="setSelectedItems"
      :updateSelectedItem="updateSelectedItem"
  />
</template>

<style scoped>
 .simplebar-custom {
   max-height: calc(100vh - 300px);
   padding-right: 2em;
 }
</style>